import { render, staticRenderFns } from "./AwardBanner.vue?vue&type=template&id=48478793&scoped=true&"
import script from "./AwardBanner.vue?vue&type=script&lang=js&"
export * from "./AwardBanner.vue?vue&type=script&lang=js&"
import style0 from "./AwardBanner.vue?vue&type=style&index=0&id=48478793&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48478793",
  null
  
)

export default component.exports